import script from "./ManifRegistroViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManifRegistroViewPage.vue?vue&type=script&setup=true&lang=js"

import "./ManifRegistroViewPage.vue?vue&type=style&index=0&id=7d9570d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d9570d0"]])

export default __exports__